var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.877 6.123A7.25 7.25 0 1 1 5.623 16.377 7.25 7.25 0 0 1 15.877 6.123Zm1.565 10.766a8.75 8.75 0 1 0-1.053 1.053.763.763 0 0 0 .06.067l3.889 3.89a.75.75 0 0 0 1.06-1.061l-3.889-3.89a.763.763 0 0 0-.067-.06Z",
    fill: "#000"
  })));
};
export default SvgIconSearch;